import { Routes, RouterModule } from "@angular/router"
import { NgModule } from "@angular/core";
import { LoginWrapperComponent } from './login-wrapper/login-wrapper.component';
import { LoginWrapperDoctorComponent } from './login-wrapper-doctor/login-wrapper-doctor.component';
import { LoginWrapperWorkersComponent } from "./login-wrapper-workers/login-wrapper-workers.component";
import { LoginMiddlewareComponent } from "./login-middleware/login-middleware.component";
import { LoginErrorMiddlewareComponent } from "./login-error-middleware/login-error-middleware.component";

const routes: Routes = [
  { path: "login-admin", component: LoginWrapperComponent, data: { perfil: "admin" } },
  { path: "login-contact", component: LoginWrapperComponent, data: { perfil: "contact" } },
  { path: "login-coordinador", component: LoginWrapperComponent, data: { perfil: "coordinador" } },
  { path: "login-gestion", component: LoginWrapperComponent, data: { perfil: "gestion" } },
  { path: "login-customer", component: LoginWrapperComponent, data: { perfil: "customer" } },
  { path: "login-doctor", component: LoginWrapperComponent, data: { perfil: "medico" } },
  { path: "login-ejecutivo", component: LoginWrapperComponent, data: { perfil: "ejecutivo" } },
  { path: "login-alianza", component: LoginWrapperComponent, data: { perfil: "cliente" } },


  { path: "login-error", component: LoginErrorMiddlewareComponent },
    { path: 'login-middleware/:idTransaction/:tipoPago', component: LoginMiddlewareComponent },

  { path: "login", component: LoginWrapperComponent, data: { perfil: "paciente" } },
];


@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class AuthRoutingModule { }